import { Component, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-app-settings',
  templateUrl: './app-settings.component.html',
  styleUrls: ['./app-settings.component.css']
})
export class AppSettingsComponent {
    window:any= <any>window;
    $:any=<any>this.window.$;
    notification:any = new this.window.HPNotification();
    queryparams:any = () => this.route.snapshot.queryParams;
    params:any = () => this.route.snapshot.params;
    changeQueryParam:any = (values:any = {}) => new Object({ ...this.route.snapshot.queryParams, ...values });
    updateView:any = () => {
        setTimeout(() => {
            this.cd.detectChanges();
        }, 50);
    };
    rand = (num:any = null) => {
        num = num || 12;
        var text = "";
        var characters = "_ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < num; i++) {
            text += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return text;
    };

    temp:any = {filter_text: ''};
    constructor(
        private cd: ChangeDetectorRef,
        private route:ActivatedRoute,
        private router:Router
    ) {
        route.queryParams.subscribe((p:any) => this.updateView());
    }

    getImages = async (input:any = undefined) => {
        this.window.flowup.signal.emit({name: 'get-files', detail: {
            event: input,
            callback: (parsed_files) => {
                if(!this.window.usher.get().public_configuration?.images) this.window.usher.get().public_configuration.images = [];        
                this.window.flowup.signal.emit({name: 'upload-files', detail: {
                    collection: parsed_files,
                    callback: async (sent) => {
                        this.window.usher.get().public_configuration?.images.push(...sent.map(s => new Object({
                            ...s,
                            type: 'myself_images',
                            target: this.window.usher.getPublicToken(),
                            owner: this.window.usher.getPublicToken()
                        })));
                        try {
                            await this.window.usher.updateMySelf();
                            this.updateView();
                            return this.notification.success({text: "Immagini aggiornate con successo."});
                        } catch(e) {
                            console.log(e);
                            return this.notification.danger({text: "Errore. Riprova più tardi."});
                        }
                    },
                    error: (file) => {
                        return this.notification.danger({text: `Errore nel caricamento del file ${file.filename}`});
                    }
                }});
            }
        }});
    };

    update = async () => {
        try {
            await this.window.usher.updateMySelf();
            this.notification.success({text: "Aggiornamento avvenuto con successo"});
        } catch(e) {
            console.log(e);
        }
    };

    getPicture = (name:any) => `${this.window.appInfo.url_media}/public/${name}`;
}